import matriz_model from './matriz_model';
import material_categoria_model from './material_categoria_model';

export default {
  Codigo: null,
  Descripcion: '',
  CodigoMatriz: null,
  CodigoMaterialCategoria: null,
  Material: 0,
  SentidoBobinado: null,
  DimensionAlto: 0,
  DimensionAncho: 0,
  BocasAncho: 0,
  BocasAnchoFinales: null,
  BocasAlto: 0,
  BocasLargo: 0,
  Activo: true,
  Adicional: 0,
  Cantidad: 0,
  Costo: 0,
  Velocidad: 0,
  VelocidadManual: 0,
  Recurso: 0,
  Obervaciones: 0,
  Espesor: 0,
  Gramaje: 0,
  MultiMaterial: 0,
  Porcentaje: 0,
  CantidadColoresFrente: 0,
  CantidadColoresLiner: 0,
  CantidadColoresAdhesivo: 0,
  CantidadCambios: 0,
  Colores: 0,
  Matriz: { ...matriz_model },
  MaterialCategoria: { ...material_categoria_model },
  FueraDeLinea: false,
};
